import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { shouldNoindexPath } from '@/lib/seo-robots';

function setRobotsMeta(content: string | null) {
  let el = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
  if (content === null) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', 'robots');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Applique `noindex, nofollow` sur les zones applicatives ; `index, follow` sur le marketing public. */
export function useSeoRobots() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (shouldNoindexPath(pathname)) {
      setRobotsMeta('noindex, nofollow');
      return;
    }
    setRobotsMeta('index, follow');
  }, [pathname]);
}
